<template>

    <div class="navigation-bar-wrapper" data-aos="fade-in">
        <div class="navigation-bar px-2">
            <div class="left">
                <div class="menu-btn" ref="menuToggle" @click="toggleMenu"></div>
                <a href="/" class="brand">
                    <img :src="logoUrl" alt="">
                </a>
            </div>
            <div class="right">
                <b-dropdown variant="link" no-caret right>
                    <template #button-content>
                        <div class="language-btn">{{ CONFIG.currentLocale }}</div>
                    </template>
                    <b-dropdown-item v-for="(name, code) in CONFIG.availableLocales" :key="code" :active="CONFIG.currentLocale === code" :href="'/set-locale/' + code">{{ name }}</b-dropdown-item>
                </b-dropdown>
                <b-dropdown variant="link" no-caret right>
                    <template #button-content>
                        <div class="user-btn"></div>
                    </template>
                    <b-dropdown-item href="/logout">{{ t.__('Wyloguj') }}</b-dropdown-item>
                </b-dropdown>
            </div>
        </div>
        <div class="navigation-menu" v-if="showMenu" ref="navMenu">
            <div class="close-btn" @click="toggleMenu"></div>
            <div class="menu-items">
                <a href="/info" class="menu-item">{{ t.__('Informacje o urządzeniu') }}</a>
                <a href="/my-quizzes" v-if="machine.has_my_quizzes_package" class="menu-item">{{ t.__('Moje quizy') }}</a>
                <a href="/resources" v-if="machine.repo !== 'prod'" class="menu-item">{{ t.__('Materiały dydaktyczne') }}</a>
                <a href="/vip-area" v-if="machine.has_presentationgame_package || machine.has_personalized_games" class="menu-item">{{ t.__('Obszar VIP') }}</a>
                <a href="/file-manager" class="menu-item">{{ t.__('Menadżer plików') }}</a>
                <a href="/available-packages" class="menu-item">{{ t.__('Dostępne pakiety') }}</a>
                <a href="/contact" class="menu-item">{{ t.__('Kontakt') }}</a>
            </div>
        </div>
    </div>

</template>

<script>

export default {

    name: 'NavigationBar',

    props: {
        machine: Object
    },

    data() {
        return {
            showMenu: false
        }
    },

    computed: {
        logoUrl() {
            let url = '/assets/images/';
            switch (CONFIG.currentLocale) {
                case 'pl':
                    url += 'logo-pl.svg';
                    break;
                case 'fr':
                    url += 'logo-fr.svg';
                    break;
                default:
                    url += 'logo-en.svg';
                    break;
            }
            return url;
        }
    },

    created() {
        window.addEventListener('click', (e) => {
            if (this.showMenu && !this.$refs.navMenu.contains(e.target) && !this.$refs.menuToggle.contains(e.target)){
                this.showMenu = false
            }
        })
    },

    mounted: function () {

    },

    beforeDestroy: function () {

    },

    methods: {
        toggleMenu() {
            this.showMenu = !this.showMenu;
        }
    }

}
</script>

<style scoped>

</style>
